<template lang="pug">
  WtTile#team-builder(ancestor vertical :col="12")
    WtTile(parent :col="12")
      WtTile(child child-class="" :col="12")
        WtTitle.team-builder-title(h2) Team Builder

    WtTile(parent :col="12")
      WtTile(child child-class="" :col="12")
        TeamBuilderSteps(
          :registrationBuilder="registrationBuilder"
          :registrationData="registrationData"
          :dismissModal="dismissModal"
          :organization="organization"
        )

</template>

<script>
import WtTile from "@@/WtTile/WtTile";
import WtTitle from "@@/WtTitle/WtTitle";
import WtButton from "@@/WtButton/WtButton";
import TeamBuilderSteps from "@@/TeamBuilder/TeamBuilderSteps";

export default {
  name: "TeamBuilder",

  components: {
    WtButton,
    WtTile,
    WtTitle,
    TeamBuilderSteps
  },

  props: {
    registrationBuilder: {
      type: Boolean,
      default: false
    },
    registrationData: {
      type: Object,
      default: () => {}
    },
    dismissModal: {
      type: Function,
      default: () => {}
    },
    organization: {
      type: Object,
      default: () => {}
    }
  }
};
</script>

<style lang="sass" scoped></style>
